import ValidService from "../../service/ValidService";

let model = {};

// dữ liệu form
model.dataForm = {
    name: null,
    code: null,
    type: null,
};


model.tableRules = {
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 20,
    offset: 0,
    sort: "name",
    defaultSort: ["name", "ascending"],
    fields: "id,disabled,code,name,index,type,center",
    filters: "",
    dataSearch: {
        value: {
            name: "",
            code: "",
            type: ""
        },
        valid: {
            // name: [ValidService.checkNameAllowVN],
            code: [ValidService.checkNumber],
            type: [ValidService.checkNameAllowVN],
        },
        operator: {
            name: ":regex_i:",
            code: ":regex_i:",
            type: ":regex_i:",
        },
    },
};

export default model;
